import { Button } from '@octopus-do/octopus-storybook'
import {
  AngleRight,
  DiamondExclamationLight,
} from '@octopus-do/octopus-storybook/icons'
import { SubscriptionActions } from '@store/reducers/subscription'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { InfoBannerContainer } from '../InfoBannerContainer'
import css from './styles.module.css'

export const BillingDetailBanner: React.FC = () => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(SubscriptionActions.requestBillingPortal())
  }

  return (
    <InfoBannerContainer>
      <div className={css.banner}>
        <div className={css.banner_icon}>
          <DiamondExclamationLight />
        </div>

        <div className={css.banner_text}>
          <div className={css.banner_title}>Update billing details</div>
          <div className={css.banner_description}>
            To avoid subscription disruption, please add a default payment
            method in Stripe.
          </div>
        </div>

        <div className={css.banner_button}>
          <Button
            size="medium"
            label="Billing details"
            right={AngleRight}
            onClick={handleClick}
          />
        </div>
      </div>
    </InfoBannerContainer>
  )
}
